import React from 'react';
import {
  Box,
  Button,
  Text,
  VStack,
  HStack,
  Grid,
  GridItem,
  Checkbox,
  Badge,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react';
import { MdCheckCircle, MdStars } from 'react-icons/md';



const CommercialTermsStep = ({ data, companySignupData, updateData, errors, touched }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleApprovalChange = (checked) => {
    updateData({
      termsApproved: checked
    });
  };

  // Helper functions to get dynamic data with fallbacks
  const getPilotData = () => {
    return companySignupData?.pilot || { enabled: true, days: 30 };
  };

  const getSetupFeeData = () => {
    return companySignupData?.setupFee || { amount: 2500, isActive: false };
  };

  const getWithdrawalFeeData = () => {
    return companySignupData?.withdrawalFee || { amount: 9.5, paidBy: 'employee', freeMonthlyCount: 0 };
  };

  const getPlanType = () => {
    return companySignupData?.planType || 'basic';
  };

  const getMonthlyFee = () => {
    return companySignupData?.monthlyFee ?? 890;
  };

  const contractContent = `תנאי השירות אלו קובעים את התנאים במסגרתם תספק פיירו לחברה ו/או לעובדי החברה שירותים בתחום תשלום גמיש של שכר (להלן: "השירותים"), ובממשקים של פיירו (ביחד: "הממשקים") והכל כפי שיפורט להלן.

1. שירותי הקדמת תשלום שכר שטרם שולם
1.1. בכפוף לתנאי הסכם זה ולמשך תקופת השירות, פיירו תספק לחברה את השירותים שבמסגרתם פיירו תאפשר לעובדי החברה לקבל, תשלום של חלק מהשכר לו הם זכאים מהחברה בגין ימי עבודה בהם עבדו (להלן: "שירות הקדמת שכר"). למען הסר ספק, תשלום הקדמת השכר יבוצע ישירות על ידי פיירו לעובדי החברה.
1.2. פיירו תעביר לחברה, לא יאוחר מה-1 בכל חודש, דו"ח מלא בגין כל עובדי החברה אשר עשו שימוש בשירות הקדמת שכר בחודש החולף (להלן: "דוח תשלומים").
1.3. שירות הקדמת השכר וזכאות עובדי החברה לעשות בו שימוש יתבסס על מידע החברה, כהגדרתו מטה. החברה תהיה האחראית הבלעדית לאמיתות, דיוק ושלמות מידע החברה ולעדכנו מעת לעת.
1.4. מובהר בזאת כי פיירו אינה נותנת לחברה ו/או לעובד כל אשראי ו/או הלוואה. השירות המסופק על ידי פיירו מאפשר לעובד לקבל חלק מהשכר לו הוא כבר זכאי בגין עבודתו בחברה. החברה תשקף בדו"ח השכר של עובדי החברה כל הקדמת שכר ששולמה לעובד על ידי פיירו ותבצע הפרשות על פי דין ו/או הסכם, לרבות בגין כל הקדמת שכר ששולמה כאמור לעיל.

2. תשלום
2.1. החברה תשלם לפיירו את סך עמלות ההעברה, דמי השימוש ואת כלל הקדמות השכר אשר הועברו לעובדי החברה על ידי פיירו בחודש נתון, במועד תשלום השכר לעובדי החברה, ובכל מקרה לא יאוחר מה-9 לחודש הרלוונטי. מובהר כי החברה אינה רשאית לקזז או להפחית כל סכום מהתשלומים לפיירו, מכל סיבה שהיא. למען הסר ספק, ייתכן שבגין מתן השירותים ייגבו תשלומים נוספים מעובדי החברה, כפי שיוסכם עם העובדים או עם החברה.
2.2. החברה מתחייבת לפרוע מיידית, וללא דיחוי, כל תשלום בו תחוב לפיירו כאמור בהוראות הסכם זה. כל תשלום אשר לא יועבר לפיירו במועדים הנקובים לעיל יישא, החל ממועד חובת ביצוע התשלום, הצמדה וריבית פיגורים בשיעור הנהוג בבנק לאומי לישראל לגבי משיכות יתר החורגות מקו אשראי בתוספת 5%, וזאת עד לפירעון מלא של התשלומים, ההצמדה וריבית הפיגורים בגינם.

3. מידע, אבטחת מידע וסודיות
3.1. פיירו מחזיקה בהסמכה פורמלית של תקן 27001 ISO ופועלת בהתאם לסטנדרטים המוגדרים בתקן.
3.2. כל זכויות הקניין הרוחני בשירותים ובממשקים או בקשר אליהם, וכן בכל שיפור, שינוי ו/או יצירה נגזרת שלהם ו/או כל פיתוח הקשור בכך, הנן ותשארנה קניינה הבלעדי של פיירו.
3.3. פיירו מצהירה כי ידוע לה כי במהלך מתן השירותים היא ו/או מי מטעמה עשויים להיחשף למידע סודי של החברה ומתחייבת כי לא תעשה במידע סודי כאמור כל שימוש, זולת הנדרש לצורך ביצוע התחייבויותיה או כפי שמותר על פי הסכם זה. לצורך סעיף זה "מידע סודי" משמעו כל מידע, ידע, סוד עסקי מכל מין וסוג שהוא ו/או כל חלק מהם, לרבות אך מבלי לגרוע, מידע כספי, שיווקי, מסחרי, טכני, תפעולי, ניהולי, נתונים ומידע אחרים, אודות הצד האחר ו/או לקוחותיו, עובדיו וספקיו מידע סודי לא יכלול כל מידע אשר: (1) הינו נחלת הכלל (2) היה ידוע לפיירו טרם גילוי המידע הסודי; (3) התגלה לפיירו על ידי צד ג' שלידיעת פיירו אינו חב חובת סודיות לחברה; (4) פותח באופן עצמאי ללא כל שימוש במידע הסודי של החברה; (5) גילויו נדרש על ידי רשות מוסמכת בישראל או מחוצה לה. מגבלות הסודיות כאמור לעיל ימשיכו לחול גם לאחר תום תקופת ההסכם, לתקופה של 3 שנים נוספות.
3.4. לצורך מתן השירותים החברה תספק ו/או תאפשר לפיירו לגשת לנתוני העסקה ומידע נלווה הנוגע לעובדי החברה – והכל על פי דרישות פיירו ומפרט המידע הנדרש בממשקים (להלן: "מידע החברה"). מידע החברה יישאר בבעלותה הבלעדית של החברה. החברה מעניקה בזאת לפיירו רשות והסכמה בלתי חוזרות לעבד את המידע לצורך מתן השירותים, לצורך תפעול ותמיכה במערכות פיירו ובמתן השירותים ולצרכי עיבוד נלווים של פיירו (לרבות ניתוח מידע מצטבר-אגרגטיבי (שאינו אישי) לצורך שיפור השירותים והמוצרים של פיירו ו/או פיתוח של שירותים ומוצרים חדשים). החברה תהיה האחראית לקבלת כל אישור נדרש לעיבוד מידע החברה על ידי פיירו, לרבות בתשתיות ענן ותשתיות ענן מחוץ למדינת ישראל. מבלי לגרוע מכלליות האמור לעיל, החברה מצהירה ומתחייבת כי מידע החברה והשימוש בו על ידי פיירו בהתאם להוראות הסכם זה, לא מפרים ולא יפרו הוראות כל דין ו/או זכויות צד שלישי (לרבות של מי מעובדי החברה).
3.5. השימוש של החברה בשירותים ובממשקים, יעשה בכפוף לתנאי השימוש ולמדיניות הפרטיות הזמינים בממשקים, כפי שיתעדכנו מעת לעת (להלן יחדיו: "תנאי השימוש").

4. שיפוי ואחריות
4.1. פיירו תשפה את החברה בגין כל נזק ו/או הוצאה ככל שייגרמו לה עקב טענה, תביעה או דרישה לפיה השירותים מפרים זכויות יוצרים של צד שלישי כלשהו, ובכפוף להוראות להלן: (א) החברה תודיע לפיירו בכתב, על טענה, תביעה ו/או דרישה כאמור ללא דיחוי; (ב) פיירו תנהל את התביעה בשם החברה, ובלבד שאם תתבקש על ידי החברה, עורך דין מטעם החברה ייצג את החברה (על חשבונה), תוך שיתוף פעולה ובשקיפות מלאה עם היועץ המשפטי של פיירו; וכן (ג) החברה תשתף פעולה עם פיירו.
4.2. הממשקים, השירותים וכל מידע המופיע בהם ניתנים כמות-שהם ("As-Is") ובכפוף לזמינותם ("As Available"). בכל מקרה, החבות המצטברת, הכוללת והמקסימאלית של פיירו בנוגע להסכם זה ו/או מתן השירותים ו/או כל קשר בינה לבין החברה, תעמוד על עד סך התמורה שהתקבלה על ידי פיירו מהחברה בתקופה של שניים עשר (12) החודשים שקדמו לתביעה הרלוונטית. מבלי לגרוע מהאמור לעיל, פיירו לא תהא אחראית לכל נזק, אובדן, פגיעה או הפסד שייגרמו לחברה או מי מטעמה לרבות עובדיה או צד שלישי כלשהו, לרבות, וללא הגבלה, נזק או פיצוי כללי, אגבי, תוצאתי, נלווה, משני, עקיף, עונשי, או מיוחד, הנובעים מהסכם זה, מהשירותים ו/או בכל הקשור אליהם, למעט כתוצאה מרשלנות רבתית ו/או פעולה מכוונת של פיירו או מי מטעמה.

5. תקופה וסיום
5.1. הסכם זה הינו ללא הגבלת זמן עד לסיומו ע״י אחד מהצדדים. כל אחד מהצדדים יהיה רשאי להביא הסכם זה לידי סיום מכל סיבה שהיא בהודעה בת 60 ימים לצד השני מראש ובכתב. הוראות סעיפים שעל פי טיבם אמורים להישאר בתוקף לאחר תום הסכם זה, יישארו בתוקפן.
5.2. כל אחד מהצדדים יהיה רשאי לסיים הסכם זה באופן מיידי במקרה של הפרה יסודית של הוראות הסכם זה ו/או של תנאי השימוש, שהפרה כאמור לא תוקנה תוך 7 ימים מיום קבלת התראה על כך, ו/או במקרה שכנגד הצד השני הוגשו הליכי פירוק ו/או הליכים לפי פקודת פשיטת רגל ו/או מונה לו ו/או לנכס מהותי שלו מנהל זמני ו/או קבוע ו/או נאמן ו/או כונס ו/או מפרק על ידי ערכאה שיפוטית.

6. שונות
6.1. החברה מסכימה לשימוש בפרטי החברה (לרבות שם, סימני מסחר ולוגו) על ידי פיירו בפרסומים מטעמה (לרבות באופן פומבי).
6.2. הסכם זה ממצה וכולל את מלוא כוונת הצדדים ורצונם המוסכם ומבטל כל הבטחה ו/או מצג ו/או התחייבות ו/או זיכרון דברים ו/או הסכם קודמים, אם וככל שנעשו ו/או נחתמו בין הצדדים, וזכויות וחובות הצדדים מעתה תהיינה אך ורק על-פי הסכם זה. אם ייקבע כי תנאי או הוראה בהסכם זה אינם חוקיים או כי לא ניתן לאכוף אותם, לא תשפיע החלטה זאת על תוקף יתר התנאים או על האפשרות לאכוף אותם. כל שינוי להסכם זה יחייב את הצדדים אך ורק אם נעשה בכתב ונחתם על-ידי שני הצדדים. שום ויתור, ארכה, הנחה או שינוי בתנאי כלשהו בהסכם זה על נספחיו, לא יהיו בני תוקף, אלא אם יעשו בכתב. שום איחור בשימוש בזכויותיו של צד כלשהו לא ייחשב כוויתור והוא יהיה רשאי להשתמש בזכויותיו כולן או בכל אחת מהן לחוד, הן לפי הסכם זה והן לפי הדין, בכל עת שימצא לנכון.
6.3. הצדדים אינם רשאים להמחות, להעביר או להסב את זכויותיהם ו/או התחייבויותיהם לפי הסכם זה, או כל חלק מהן, ללא הסכמתו של הצד השני בכתב, וכל ניסיון הסבה כאמור יהיה בטל ומבוטל. על אף האמור לעיל, פיירו רשאית להמחות, להעביר או להסב את כל זכויותיה ו/או התחייבויותיה לפי הסכם זה, ללא צורך בקבלת הסכמה כאמור, במקרה של מיזוג ו/או רכישה של מרבית נכסיה או הון מניותיה. בכל עניין הנוגע להתקשרות זו יחול הדין הישראלי בלבד עם סמכות שיפוט בלעדית לבתי המשפט המוסמכים במחוז ת״א.

תאריך: ${new Date().toLocaleDateString('he-IL')}
  `;

  return (
    <VStack spacing={6} align="stretch">
      {/* Step Title */}
      <Box textAlign="center" mb={4}>
        <Text
          fontSize={{ base: '20px', md: '24px' }}
          fontWeight="700"
          color="navy.700"
          mb={2}
        >
          תנאים מסחריים
        </Text>
      </Box>

      {/* Benefits Grid */}
      <Grid templateColumns={{ base: '1fr', md: getPilotData().enabled ? 'repeat(2, 1fr)' : '1fr' }} gap={4} mb={6} maxW="600px" mx="auto">
        {/* Pilot Period - Only show if enabled */}
        {getPilotData().enabled && (
          <GridItem>
            <Box
              bg="teal.50"
              border="1px solid"
              borderColor="teal.100"
              borderRadius="12px"
              p={4}
              textAlign="center"
            >
              <MdCheckCircle size="32px" color="green.500" style={{ margin: '0 auto 8px' }} />
              <Text fontWeight="600" color="green.500" mb={1}>
                תקופת פיילוט
              </Text>
              <Text fontSize="sm" color="gray.400">
                {getPilotData().days} יום ללא עלות
              </Text>
            </Box>
          </GridItem>
        )}

        <GridItem>
          <Box
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="12px"
            p={4}
            textAlign="center"
          >
            <MdStars size="32px" color="purple.500" style={{ margin: '0 auto 8px' }} />
            <Text fontWeight="600" color="purple.500" mb={1}>
              מסלול
            </Text>
            <Text fontSize="sm" color="gray.400">
              {getPlanType() === 'basic' ? 'בסיסי' : 'פרימיום'}
            </Text>
          </Box>
        </GridItem>
      </Grid>

      {/* Commercial Terms */}
      <Box
        bg="white"
        border="1px solid"
        borderColor="gray.200"
        borderRadius="12px"
        p={6} 
      >
        <Text fontSize="xl" fontWeight="700" color="teal.500" mb={4}>
          פירוט תנאים מסחריים
        </Text>

        <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={6} pb={4}>
          <GridItem>
            <Text fontWeight="600" color="navy.700" mb={3}>
              עלויות הקמה
            </Text>
            <VStack spacing={2} align="stretch">
              <HStack justify="space-between">
                <Text color="gray.400">דמי הקמה</Text>
                <Text
                  textDecoration={getSetupFeeData().isActive ? "none" : "line-through"}
                  color={getSetupFeeData().isActive ? "navy.700" : "gray.400"}
                  fontWeight={getSetupFeeData().isActive ? "600" : "normal"}
                >
                  ₪{getSetupFeeData().amount.toLocaleString()}
                </Text>
              </HStack>
              {/* Only show pilot period if enabled */}
              {getPilotData().enabled && (
                <HStack justify="space-between">
                  <Text color="navy.700">תקופת פיילוט ({getPilotData().days} יום)</Text>
                  <Badge colorScheme="green" variant="subtle">
                    ללא עלות
                  </Badge>
                </HStack>
              )}
            </VStack>
          </GridItem>
          
          <GridItem>
            <Text fontWeight="600" color="navy.700" mb={3}>
              עלויות תפעול
            </Text>
            <VStack spacing={2} align="stretch">
              <HStack justify="space-between">
                <Text color="gray.400">ריטיינר</Text>
                <Text fontWeight="600" color="navy.700">₪{getMonthlyFee()}</Text>
              </HStack>
              <HStack justify="space-between">
                <Text color="gray.400">
                  עמלת משיכה{getWithdrawalFeeData().paidBy === 'employee' ? ' (עובד)' : ''}
                </Text>
                <Text fontWeight="600" color="navy.700">₪{getWithdrawalFeeData().amount}</Text>
              </HStack>
            </VStack>
          </GridItem>
        </Grid>

        {/* Services and Limitations */}
        <Box pt={4} borderTop="1px solid" borderColor="gray.200">
          <Text fontWeight="600" color="navy.700" mb={3}>
            תנאי השירות
          </Text>
          <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={4}>
            <GridItem colSpan={{ base: 1, md: 2 }}>
              <VStack spacing={2} align="start">
                <HStack>
                  <MdCheckCircle color="green.500" />
                  <Text fontSize="sm">ביטול בהודעה של 30 יום</Text>
                </HStack>
              </VStack>
            </GridItem>
            {getWithdrawalFeeData().freeMonthlyCount > 0 && (
              <GridItem colSpan={{ base: 1, md: 2 }}>
                <VStack spacing={2} align="start">
                  <HStack>
                    <MdCheckCircle color="green.500" />
                    <Text fontSize="sm">משיכות חודשיות בחינם - {getWithdrawalFeeData().freeMonthlyCount}</Text>
                  </HStack>
                </VStack>
              </GridItem>
            )}
            {/* Dynamic Custom Conditions */}
            {(() => {
              try {
                const customConditions = companySignupData?.customConditionsJson
                  ? JSON.parse(companySignupData.customConditionsJson)
                  : [];
                return customConditions.map((condition, index) => (
                  <GridItem key={index} colSpan={{ base: 1, md: 2 }}>
                    <VStack spacing={2} align="start">
                      <HStack>
                        <MdCheckCircle color="green.500" />
                        <Text fontSize="sm">{condition.text}</Text>
                      </HStack>
                    </VStack>
                  </GridItem>
                ));
              } catch {
                return null;
              }
            })()}
          </Grid>
        </Box>
      </Box>

      {/* Services Included */}
      <Box
        bg="white"
        border="1px solid"
        borderColor="gray.200"
        borderRadius="12px"
        p={6}
      >
        <Text fontSize="lg" fontWeight="600" color="navy.700" mb={4}>
          שירותים כלולים
        </Text>
        <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={4}>
          <GridItem>
            <VStack spacing={2} align="start">
              <HStack>
                <MdCheckCircle color="green.500" />
                <Text fontSize="sm">דוחות ואנליטיקה</Text>
              </HStack>
            </VStack>
          </GridItem>
          <GridItem>
            <VStack spacing={2} align="start">
              <HStack>
                <MdCheckCircle color="green.500" />
                <Text fontSize="sm">תמיכה טכנית 24/7</Text>
              </HStack>
            </VStack>
          </GridItem>
        </Grid>
      </Box>

      {/* Approval Section */}
      <Box
        bg="teal.50"
        border="1px solid"
        borderColor="teal.100"
        borderRadius="12px"
        p={6}
      >
        <HStack align="start" spacing={3}>
          <Checkbox
            isChecked={data.termsApproved}
            onChange={(e) => handleApprovalChange(e.target.checked)}
            colorScheme="teal"
            size="lg"
            borderColor="teal.500"
            sx={{
              '& .chakra-checkbox__control[data-checked]': {
                bg: 'teal.500',
                borderColor: 'teal.500',
              },
              '& .chakra-checkbox__control:hover': {
                borderColor: 'teal.500',
                boxShadow: '0 0 0 3px teal.300',
                transform: 'scale(1.05)',
              },
              '& .chakra-checkbox__control': {
                transition: 'all 0.2s ease-in-out',
              }
            }}
          />
          <VStack align="start" spacing={1}>
            <Text color="navy.700" fontWeight="500">
              אני מאשר/ת את התנאים המסחריים ואת{' '}
              <Button
                variant="link"
                color="teal.500"
                textDecoration="underline"
                onClick={onOpen}
                p={0}
                h="auto"
                minW="auto"
              >
                תנאי השימוש
              </Button>
            </Text>
            <Text fontSize="sm" color="gray.400">
              על ידי סימון תיבה זו אני מאשר/ת את כלל התנאים המפורטים לעיל
            </Text>
          </VStack>
        </HStack>
      </Box>

      {/* Contract Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent maxH="80vh" dir="rtl">
          <ModalHeader textAlign="right">הסכם התקשרות</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6} overflowY="auto">
            <Text
              whiteSpace="pre-wrap"
              fontSize="sm"
              lineHeight="relaxed"
              textAlign="right"
              dir="rtl"
              fontFamily="Arial, sans-serif"
            >
              {contractContent}
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </VStack>
  );
};

export default CommercialTermsStep;
